<div class="u-modal">
    <div class="u-modal-body">
        <ng-content></ng-content>
    </div>
</div>
<div class="u-modal-background"></div>